"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataExtractor = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const core_shared_2 = require("@ikegps/core-shared");
const index_1 = require("../../i18n/index");
const services_1 = require("../../services");
const LOCATION_PRECISION = 5;
/**
 * The DataExtractor class provides static methods for extracting printable values from CollectionModelField objects.
 */
class DataExtractor {
    /**
     * Creates a printable report item from a CollectionModelField.
     * @param field - The CollectionModelField object.
     * @returns The PrintableReportItem object.
     */
    static createPrintableValue(field) {
        const printable = { title: field.schema.displayName, value: null };
        if (field.hasValue()) {
            printable.value = this.extract(field);
        }
        return printable;
    }
    static extract(field) {
        switch (true) {
            case field instanceof core_shared_1.CollectionModelFieldSubForm:
            case field instanceof core_shared_1.CollectionModelFieldImage:
            case field instanceof core_shared_1.CollectionModelFieldTrueSize:
                return null;
            case field instanceof core_shared_1.CollectionModelFieldLocation:
                return this.extractLocation(field);
            case field instanceof core_shared_1.CollectionModelFieldVector:
                return this.extractVector(field);
            case field instanceof core_shared_1.CollectionModelFieldAnchor:
                return this.extractAnchor(field);
            case field instanceof core_shared_1.CollectionModelFieldHeight:
                return this.extractHeight(field);
            case field instanceof core_shared_1.CollectionModelFieldNumber:
                return this.extractNumber(field);
            case field instanceof core_shared_1.CollectionModelFieldYesNo:
                return this.extractYesNo(field);
            case field instanceof core_shared_1.CollectionModelFieldSelectList:
                return this.extractSelectList(field);
            case field instanceof core_shared_1.CollectionModelFieldVerticalSeparation:
                return this.extractVerticalSeparation(field);
            default:
                return this.extractString(field);
        }
    }
    static extractLocation(field) {
        const lat = core_shared_2.IkeUnit.round(field.value.latitude, LOCATION_PRECISION);
        const lng = core_shared_2.IkeUnit.round(field.value.longitude, LOCATION_PRECISION);
        if (field.value.altitude != null) {
            const alt = core_shared_2.IkeUnit.display(field.value.altitude, services_1.Services.UserSettings.units);
            return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_LAT_LNG_ALT, { lat, lng, alt });
        }
        else {
            return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_LAT_LNG, { lat, lng });
        }
    }
    static extractVector(field) {
        const distance = core_shared_2.IkeUnit.display(field.value.distance, services_1.Services.UserSettings.units);
        const bearing = core_shared_2.IkeUnit.displayAngle(field.value.bearing, core_shared_2.IkeUnit.DEGREE);
        return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_VECTOR, { distance, bearing });
    }
    static extractAnchor(field) {
        if (core_shared_1.CollectionModelFieldAnchor.isCollectionWithVectorTool(field.value)) {
            const distance = core_shared_2.IkeUnit.display(field.value.distance, services_1.Services.UserSettings.units);
            const bearing = core_shared_2.IkeUnit.displayAngle(field.value.bearing, core_shared_2.IkeUnit.DEGREE);
            return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_VECTOR, { distance, bearing });
        }
        if (core_shared_1.CollectionModelFieldAnchor.isCollectionWithLocationTool(field.value)) {
            const lat = core_shared_2.IkeUnit.round(field.value.latitude, LOCATION_PRECISION);
            const lng = core_shared_2.IkeUnit.round(field.value.longitude, LOCATION_PRECISION);
            if (field.value.altitude != null) {
                const alt = core_shared_2.IkeUnit.display(field.value.altitude, services_1.Services.UserSettings.units);
                return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_LAT_LNG_ALT, { lat, lng, alt });
            }
            else {
                return (0, index_1.Translate)(index_1.T.REPORT_COLLECTION_LAT_LNG, { lat, lng });
            }
        }
        throw new Error('Unknown anchor tool');
    }
    static extractHeight(field) {
        return core_shared_2.IkeUnit.display(field.value, services_1.Services.UserSettings.units);
    }
    static extractNumber(field) {
        if (field.isSag()) {
            return core_shared_2.IkeUnit.display(field.value, services_1.Services.UserSettings.units);
        }
        if (field.isBearing() || field.isBackBearing()) {
            return core_shared_2.IkeUnit.displayAngle(field.value, core_shared_2.IkeUnit.DEGREE);
        }
        return field.displayValue;
    }
    static extractYesNo(field) {
        return (0, index_1.Translate)(field.value ? index_1.T.YES : index_1.T.NO);
    }
    static extractSelectList(field) {
        return field.displayValue;
    }
    static extractVerticalSeparation(field) {
        return core_shared_2.IkeUnit.display(field.value, core_shared_2.IkeUnit.INCH, null, null, 0);
    }
    static extractString(field) {
        return field.displayValue;
    }
}
exports.DataExtractor = DataExtractor;
//# sourceMappingURL=DataExtractor.js.map